__turbopack_context__.v({
  "blocksBackgroundColor": "TranslateButton-module-scss-module__VPRMLW__blocksBackgroundColor",
  "blocksFontColor": "TranslateButton-module-scss-module__VPRMLW__blocksFontColor",
  "secondaryNavBackgroundColor": "TranslateButton-module-scss-module__VPRMLW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "TranslateButton-module-scss-module__VPRMLW__themeBackgroundColor",
  "themeFontColor": "TranslateButton-module-scss-module__VPRMLW__themeFontColor",
  "translateButton": "TranslateButton-module-scss-module__VPRMLW__translateButton",
});
